import React from 'react';

/**
 * Formats raw KJV verse text into React elements
 * Handles:
 *   ¶  → pilcrow paragraph marker
 *   [word] → italicized (translator-supplied words)
 *   ‹text› → red-letter (words of Jesus)
 */
export function formatVerse(raw) {
  if (!raw) return null;

  // Build a token list by parsing the string
  const tokens = [];
  let i = 0;
  while (i < raw.length) {
    if (raw[i] === '¶') {
      tokens.push({ type: 'pilcrow' });
      i++;
      // skip trailing space
      if (raw[i] === ' ') i++;
    } else if (raw[i] === '[') {
      const end = raw.indexOf(']', i);
      if (end !== -1) {
        tokens.push({ type: 'italic', text: raw.slice(i + 1, end) });
        i = end + 1;
      } else {
        tokens.push({ type: 'text', text: raw[i] });
        i++;
      }
    } else if (raw[i] === '\u2039') { // ‹
      const end = raw.indexOf('\u203A', i); // ›
      if (end !== -1) {
        tokens.push({ type: 'red', text: raw.slice(i + 1, end) });
        i = end + 1;
      } else {
        tokens.push({ type: 'text', text: raw[i] });
        i++;
      }
    } else {
      // Collect plain text
      let j = i;
      while (j < raw.length && raw[j] !== '¶' && raw[j] !== '[' && raw[j] !== '\u2039') {
        j++;
      }
      tokens.push({ type: 'text', text: raw.slice(i, j) });
      i = j;
    }
  }

  return tokens.map((tok, idx) => {
    switch (tok.type) {
      case 'pilcrow':
        return <span key={idx} className="pilcrow">¶ </span>;
      case 'italic':
        return <span key={idx} className="italic-word">{tok.text}</span>;
      case 'red':
        return <span key={idx} className="red-letter">{tok.text}</span>;
      default:
        return <React.Fragment key={idx}>{tok.text}</React.Fragment>;
    }
  });
}

/**
 * Strip all formatting markers to get plain text for searching
 */
export function stripFormatting(raw) {
  if (!raw) return '';
  return raw
    .replace(/¶\s*/g, '')
    .replace(/[\[\]\u2039\u203A]/g, '');
}
